import { type QueryHookOptions, useQuery } from "@apollo/client";
import { LinksListQuery } from "../graphql/queries";
import type { LinksListQueryType } from "@/types/graphql/partner.generated";

export const useLinksQuery = (
  options?: QueryHookOptions<LinksListQueryType>
) => {
  return useQuery<LinksListQueryType>(LinksListQuery, options);
};
